<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="normal"
      notFooterPadding
  >
    <template #header>
      {{isMeaningful(item) ? '查看' : '填写'}}Case信息
    </template>
    <template #content>
      <el-form
          :model="form"
          :label-position="'left'"
          label-width="80px"
          ref="form"
      >
        <el-form-item
            prop="caseId"
            label="Case ID"
            :rules="[
              {required: true, message: '请输入Case ID', trigger: ['blur', 'change'] },
              $gjReRule(RE.pt, '请输入正确的Case ID')
            ]"
        >
          <gj-input
              v-model="form.caseId"
              :disabled="isMeaningful(item)"
              width="340px"></gj-input>
        </el-form-item>
        
      </el-form>
    </template>
    <template #footer>
      <gj-button @click="cancel">{{isMeaningful(item) ? '关闭' : '取消'}}</gj-button>
      <template v-if="!isMeaningful(item)">
        <gj-button @click="confirm" type="primary" :loading="loading">确定</gj-button>
      </template>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, isMeaningfulMixin, modalMixIn} from "@/minxins";
  import {isMeaningful} from "@/utils/common";
  import {updateReturnGoodsClaim} from "@/api/sale";

  export default {
    name: "claim-goods-input-case",
    mixins: [modalMixIn, formRuleMixin, isMeaningfulMixin],
    props: {
      id: null,
      caseId: null,
      msku: null,
      item: null,
    },
    created() {
      this.form.id = this.id;
      this.form.caseId = this.caseId;
    },
    data() {
      return {
        loading: false,
        form: {
          id: null,
          caseId: null,
        }
      }
    },
    methods: {
      confirm() {
        if (this.$gjFormValidate()) {
          this.loading = true;
          updateReturnGoodsClaim(this.form)
            .then((data) => {
              if (data) {
                this.$gjMessage.success('操作成功！请在已索赔数据中查看索赔结果');
                this.$emit('after');
              } else {
                this.$gjMessage.error(res.msg);
              }
            }).complete(() => this.loading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .input-case-title {
    font-size: 12px;
    color: #666;
    margin-left: 12px;
  }
  ///deep/ .el-form-item{
  //  &:last-child{
  //    margin-bottom: 0;
  //  }
  //}
</style>
